import { forwardRef } from 'react';
import './Button.css';

const IconButton = forwardRef(({
  children,
  label,
  variant = 'ghost',
  size = 'md',
  className = '',
  type = 'button',
  ...props
}, ref) => {
  if (!label) {
    throw new Error('IconButton requires a non-empty label for its accessible name.');
  }

  return (
    <button
      ref={ref}
      type={type}
      className={`rds-icon-button rds-focusable rds-button--${variant} rds-icon-button--${size} ${className}`.trim()}
      aria-label={label}
      {...props}
    >
      <span className="rds-icon-button__icon" aria-hidden="true">{children}</span>
    </button>
  );
});

IconButton.displayName = 'IconButton';

export default IconButton;
